import React from "react";
import PropTypes from "prop-types";

const ComplaintErrorModal = ({ isOpen, setIsOpen, errorMessage }) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent overlay
        backdropFilter: "blur(2px)",          // reduced blur effect
      }}
      tabIndex="-1"
      aria-labelledby="complaintErrorModalLabel"
      aria-hidden="true"
    >
      {/* Center the modal vertically */}
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          {/* Modal Header with updated background color and no X button */}
          <div className="modal-header" style={{ backgroundColor: "#f2f6fd" }}>
            <h5
              className="modal-title"
              id="complaintErrorModalLabel"
              style={{ color: "#000" }} // dark text for readability
            >
              Submission Error
            </h5>
          </div>
          {/* Modal Body */}
          <div className="modal-body">
            <p>
              {errorMessage ||
                "Failed to submit complaint. Please try again."}
            </p>
          </div>
          {/* Modal Footer with a full-width Close button */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary w-100 fw-semibold"
              onClick={() => setIsOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ComplaintErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

export default ComplaintErrorModal;
